import { VODCSSModules } from 'shared/utils/wix-connect';

import styles from './videos.styl';


@VODCSSModules(styles)
export default class Videos extends React.Component {

  render() {
    // TODO wrap each video with container to provide playback actions like onPlayRequested
    // wrapper, not pure actions needed because of different logic for views
    // Also can be done as view specific actions (need to discuss)
    return (
      <div styleName="container">
        TODO 4 videos
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/views/desktop/compact/components/videos/videos.js